var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalog",
    clipPath: "url(#clip0_18_1951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 872,
    transform: "translate(-1334 -285)",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Standard Prime SKU"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component 17/tab Standard Prime"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Standard Prime SKU List",
    filter: "url(#filter0_d_18_1951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1219,
    height: 243,
    transform: "translate(-1128 -52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 48095783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1219,
    height: 42,
    transform: "translate(-1128 -12)",
    fill: "#F7931E",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 48095771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action/icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clarity:edit-solid",
    clipPath: "url(#clip1_18_1951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.11 11.6L1.16 15.7C1.12723 15.8498 1.12836 16.0051 1.16329 16.1545C1.19823 16.3039 1.2661 16.4436 1.36194 16.5634C1.45778 16.6832 1.57917 16.7801 1.71724 16.847C1.85532 16.9138 2.00659 16.949 2.16 16.95C2.23149 16.9572 2.30352 16.9572 2.375 16.95L6.5 16L14.42 8.10995L10 3.69995L2.11 11.6Z",
    fill: "#1D3679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9099 4.15998L13.9599 1.20999C13.7659 1.01702 13.5035 0.908691 13.2299 0.908691C12.9563 0.908691 12.6938 1.01702 12.4999 1.20999L10.8599 2.84998L15.2749 7.26499L16.9149 5.62499C17.0108 5.52852 17.0868 5.41409 17.1385 5.28822C17.1902 5.16235 17.2166 5.02752 17.2162 4.89145C17.2157 4.75538 17.1884 4.62073 17.1358 4.49522C17.0833 4.36971 17.0065 4.25579 16.9099 4.15998Z",
    fill: "#1D3679"
  }))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_1951",
    x: -1132,
    y: -55,
    width: 1227,
    height: 251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_1951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_1951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 872,
    fill: "white",
    transform: "translate(-1334 -285)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_1951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/editPenIcon.684d9ebc01125c5674c3489c3f750666.svg";
export { ForwardRef as ReactComponent };